import * as TeamMember from '../schemas/inductions/VivaEnergy/TeamMember.json'
import * as Contractor from '../schemas/inductions/VivaEnergy/Contractor.json'
import * as DeliveryDriver from '../schemas/inductions/VivaEnergy/DeliveryDriver.json'
import * as SecurityOfficer from '../schemas/inductions/VivaEnergy/SecurityOfficer.json'
import * as Supplier from '../schemas/inductions/VivaEnergy/Supplier.json'
import * as UnregisterContractor from '../schemas/inductions/VivaEnergy/UnregisteredContractor.json'
import * as Visitor from '../schemas/inductions/VivaEnergy/Visitor.json'

export default {
    type: 'Viva Energy Induction',
    schemas: {
        'Team Member': TeamMember,
        'Contractor': Contractor,
        'Delivery Driver': DeliveryDriver,
        'Security Officer': SecurityOfficer,
        'Supplier': Supplier,
        'Unregistered Contractor': UnregisterContractor,
        'Visitor': Visitor
    }
}
